module.exports = __webpack_public_path__ + "assets/835ab21d0a05f9a17a5c2798334946d5.mp3";